import { all, call, put, select } from 'redux-saga/effects';
import { apiRequest } from '../../../api/api.saga-services';
import * as meetingFolderResourceService from '../../../resource/meeting-folder/meeting-folder.saga-service';
import * as api from '../../../api/request-config/meeting-folder.api';
import * as types from './meeting-folder.types';
import * as constants from './meeting-folder.constants';
import { closeDialog } from '../../../dialog/dialog.actions';
import * as pageActions from './meeting-folder.actions';
import { IMeetingFolderUpdatePayload } from './meeting-folder.types';
import { IMeetingFolder } from '../../../resource/meeting-folder/meeting-folder.types';
import { meetingsFoldersPageSelectors } from './meeting-folder.selectors';

export function* fetchMeetingFolders() {
  const meetingFolders = yield call(apiRequest, api.fetchMeetingFoldersApi());
  if (!meetingFolders) {
    return;
  }

  yield all(
    meetingFolders.map((meetingFolder: IMeetingFolder) =>
      call(meetingFolderResourceService.storeMeetingFolder, meetingFolder),
    ),
  );
  yield put(
    pageActions.storeMeetingFoldersIds(meetingFolders.map((meetingFolder: IMeetingFolder) => meetingFolder.id)),
  );
}

export function* createMeetingFolder(payload: any) {
  const newMeetingFolder = yield call(apiRequest, api.createMeetingFolderApi(payload));
  if (!newMeetingFolder) {
    return;
  }

  yield call(meetingFolderResourceService.storeMeetingFolder, newMeetingFolder);

  let meetingFoldersIds = (yield select(
    meetingsFoldersPageSelectors.selectMeetingFoldersIds,
  )) as IMeetingFolder['id'][];
  meetingFoldersIds = [...meetingFoldersIds, newMeetingFolder.id];
  yield put(pageActions.storeMeetingFoldersIds(meetingFoldersIds));

  yield put(closeDialog('meetingFolderFormDialog'));
}

export function* updateMeetingFolder(meetingFolderId: IMeetingFolder['id'], payload: IMeetingFolderUpdatePayload) {
  const updatedMeetingFolderFolder = yield call(apiRequest, api.updateMeetingFolderApi(meetingFolderId, payload));
  if (!updatedMeetingFolderFolder) {
    return;
  }

  yield call(meetingFolderResourceService.storeMeetingFolder, updatedMeetingFolderFolder);
}

export function* deleteMeetingFolder(meetingFolderId: IMeetingFolder['id']) {
  const deletedFolder = yield call(apiRequest, api.deleteMeetingFolderApi(meetingFolderId));
  if (!deletedFolder) {
    return;
  }
  const meetingFoldersIds = (yield select(
    meetingsFoldersPageSelectors.selectMeetingFoldersIds,
  )) as IMeetingFolder['id'][];

  yield put(pageActions.storeMeetingFoldersIds(meetingFoldersIds.filter((id) => id !== meetingFolderId)));
  yield put(closeDialog('confirmation'));
}

export const storeMeetingFolders = (meetingsSimpleIds: IMeetingFolder['id'][]): types.IStoreMeetingFolder => ({
  type: constants.STORE_MEETING_FOLDER_IDS,
  payload: meetingsSimpleIds,
});
